<template>
  <article id="nim-student-home" class="nim-student-surface nim-project-home" :data-theme="studentTheme">
    <button class="nim-theme-toggle" type="button" @click="toggleStudentTheme" :aria-label="studentTheme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'" :title="studentTheme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'">{{ studentTheme === 'dark' ? '☀' : '☾' }}</button>
    <div class="homeContainer">


      <div class="mainView">
        <header class="nim-student-hero">
          <span class="nim-badge">Next Idea Matters</span>
          <h1>Your ideas. <span>Your impact.</span></h1>
          <p>Build with your team, develop your project and share what you discover.</p>
        </header>
        <el-tabs v-model="activeName" style="font-size: 25px;">
          <el-tab-pane v-if="showOngoing" label="Pending Payment" name="first">

            <div class="projectList">


              <div class="itemStyle" v-for="item in pendingList">



                <div style="display: table"></div>

                <!-- <div :class="item.application_team_code == '' ? 'teamCodeStyle1' : 'teamCodeStyle'">
                    {{ item.application_team_code == '' ? 'Awaiting Team Confirmation' : ('#' + item.application_team_code)}}
                  </div> -->

                <div class="projectTitleStylePending">
                  {{ item.project_name || item.event || item.application_project }}
                </div>

                <div class="leaderStyle">
                  Please complete the payment in EAE to complete your registration.
                </div>

                <!-- <div class="memberStyle">
                    Members:{{ item.memberName }}
                  </div> -->


                <!-- <div class="infoStyle">
                   Progress: {{item.progress}}  Word Count: {{item.word_count}}
                  </div> -->

                <div class="pendingButtons">
                  <el-button type="primary" class="pendingBtn" @click="gotoEAE(item)">Go to EAE System</el-button>
                  <el-button type="primary" class="pendingBtn" @click="RemoveItem(item)">Cancel</el-button>
                </div>

              </div>

            </div>


          </el-tab-pane>
          <el-tab-pane :label="'Ongoing Projects (' + projectLists.length + ')'" name="second">


            <div class="projectList">


              <div v-for="(item, index) in projectLists" :key="index"
                :class="isTeamReady(item) ? 'newItem newItem1' : 'newItem'">
                <div v-if="createNimImgResource(item.application_project) != ''" style="margin-right: 15px;">
                  <img :src="createNimImgResource(item.application_project)"
                    style="width: 100px;height: auto;object-fit: cover;">
                </div>
                <div style="flex: 1;box-sizing: border-box;min-height: 100%;display: flex;flex-direction: column;">
                  <div style="display: flex;align-items: center;">
                    <div style="flex: 1;">
                      <div :class="isTeamReady(item) ? 'teamCodeStyle' : 'teamCodeStyle1'">
                        {{ teamStatusText(item) }}
                      </div>
                    </div>
                    <div class="infoStyle">
                      Progress: {{ item.progress }} Word Count: {{ item.word_count }}
                    </div>
                  </div>
                  <div class="projectTitleStyle" style="flex: 1;">
                    {{ item.event ? toPlainText(item.event) : 'Please Fill in the Project Title Module' }}
                  </div>
                  <div style="display: flex;align-items: flex-end;min-height: 56px;">
                    <div style="flex: 1;">
                      <div class="leaderStyle">
                        Leader:{{ item.leaderName }}
                      </div>
                      <div class="memberStyle">
                        Members:{{ item.memberName }}
                      </div>
                    </div>
                    <div>
                      <div v-if="isTeamReady(item)">
                        <div style="display: flex;">
                          <el-button type="primary" v-if="item.submit_status == 'show'" @click="doSubmitProject(item)"
                            class="manageStyle1">Submit</el-button>
                          <div v-if="item.submit_status == 'disabled'"
                            style="display: flex;gap: 5px;margin-right: 10px;">
                            <p style="color: #333;font-size: 14px;"
                              v-html="'Results expected on  <br>' + formatPublishDate(item)"></p>
                            <el-button type="primary" class="manageStyle1"
                              style="background-color: gray;">Submitted</el-button>
                          </div>

                          <template v-if="checkShowCertView(item)">
                            <el-button type="primary" class="manageStyle2"
                              @click="gotoAwardView(item)">Achievement Kit</el-button>
                          </template>

                          <el-button
                            v-if="!isProjectCompleted(item) && (item.entry_submission_deadline == '' || item.entry_submission_deadline >= new Date().getTime())"
                            type="primary" class="manageStyle1" @click="manageProject(item)">Manage</el-button>
                          <el-button v-if="isProjectCompleted(item)"
                            type="primary" class="manageStyle1" @click="viewPublicProject(item)">View Project</el-button>
                          <el-button
                            v-if="!isProjectCompleted(item) && !checkShowCertView(item) && item.entry_submission_deadline != '' && item.entry_submission_deadline < new Date().getTime()"
                            type="primary" class="manageStyle1" @click="getPdf(item)">View</el-button>
                        </div>
                      </div>
                      <div v-if="!isTeamReady(item)">
                        <!-- <el-button v-if="item.entry_submission_deadline == '' || item.entry_submission_deadline >= new Date().getTime()" type="primary" class="manageStyle" @click="createTeam(item)">Create A Team</el-button> -->
                        <div class="advisorHintStyle">{{ teamPendingHint(item) }}</div>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- <div style="display: table"></div> -->

                <!-- <div :class="item.application_team_code == '' ? 'teamCodeStyle1' : 'teamCodeStyle'">
                  {{ item.application_team_code == '' ? 'Awaiting Team Confirmation' : ('#' +
                    item.application_team_code) }}
                </div> -->

                <!-- <div class="projectTitleStyle">
                  {{ item.event }}
                </div> -->

                <!-- <div class="leaderStyle">
                  Leader:{{ item.leaderName }}
                </div>

                <div class="memberStyle">
                  Members:{{ item.memberName }}
                </div> -->


                <!-- <div class="infoStyle">
                  Progress: {{ item.progress }} Word Count: {{ item.word_count }}
                </div> -->


                <!-- <div v-if="item.application_team_code != ''">
                  <el-button
                    v-if="item.entry_submission_deadline == '' || item.entry_submission_deadline >= new Date().getTime()"
                    type="primary" class="manageStyle" @click="changeTeam(item, 'Switch Team')">Switch Team</el-button>
                  <el-button
                    v-if="item.entry_submission_deadline == '' || item.entry_submission_deadline >= new Date().getTime()"
                    type="primary" class="manageStyle" @click="manageProject(item)">Manage</el-button>
                  <el-button
                    v-if="item.entry_submission_deadline != '' && item.entry_submission_deadline < new Date().getTime()"
                    type="primary" class="manageStyle" @click="getPdf(item)">View</el-button>
                </div>
                <div v-if="item.application_team_code == ''">
                  <el-button v-if="item.entry_submission_deadline == '' || item.entry_submission_deadline >= new Date().getTime()" type="primary" class="manageStyle" @click="createTeam(item)">Create A Team</el-button> -->
                <!-- <el-button
                  v-if="item.entry_submission_deadline == '' || item.entry_submission_deadline >= new Date().getTime()"
                  type="primary" class="manageStyle" @click="changeTeam(item, 'Join My Team')">Join My
                  Team</el-button> -->
              </div>
            </div>

          </el-tab-pane>


          <el-tab-pane :label="'History Projects (' + historyList.length + ')'" name="third">

            <div class="projectList">

              <div v-for="(item, index) in historyList" :key="index"
                :class="item.application_team_code == '' ? 'itemStyle2' : 'itemStyle'">

                <div class="historyContent">
                  <div :class="item.application_team_code == '' ? 'teamCodeStyle1' : 'teamCodeStyle'">
                    {{ item.application_team_code == '' ? 'Awaiting Team Confirmation' : ('#' +
                      item.application_team_code) }}
                  </div>

                  <div class="projectTitleStyle">
                    {{ toPlainText(item.event) }}
                  </div>

                  <div class="leaderStyle">
                    Leader: {{ item.leaderName }}
                  </div>

                  <div class="memberStyle">
                    Members: {{ item.memberName }}
                  </div>
                </div>

                <!-- <div class="infoStyle">
                  Progress: {{item.progress}}  Word Count: {{item.word_count}}
                  </div> -->

                <div v-if="item.application_team_code != ''" class="historyButtons">
                  <el-button
                    v-if="!isProjectCompleted(item) && (item.entry_submission_deadline == '' || item.entry_submission_deadline >= new Date().getTime())"
                    type="primary" class="manageStyle" @click="manageProject(item)">Manage</el-button>
                  <el-button v-if="isProjectCompleted(item)"
                    type="primary" class="manageStyle" @click="viewPublicProject(item)">View Project</el-button>
                  <template v-if="checkShowCertView(item)">
                    <el-button type="primary" class="manageStyle2"
                      @click="gotoAwardView(item)">Achievement Kit</el-button>
                  </template>
                  <el-button
                    v-else-if="!isProjectCompleted(item) && item.entry_submission_deadline != '' && item.entry_submission_deadline < new Date().getTime()"
                    type="primary" class="manageStyle" @click="getPdf(item)">View</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>





    </div>

    <el-dialog class="dialog" :title="teamChange.title" :visible.sync="teamChange.show" :close-on-click-modal="false"
      :show-close="false" width="80%" @open="openDialog" @close="closeDialog">


      <el-input placeholder="Please search by the email of the target team's leader" v-model="teamChange.teamSearchText"
        clearable>
        <template slot="append">
          <el-button icon="el-icon-search" @click="handleTeamSearch">Search</el-button>
        </template>
      </el-input>

      <el-table :data="teamChange.team_apps" style="width: 100%" empty-text="No Data">
        <el-table-column prop="student_info.student_name" label="Name" width="180"></el-table-column>
        <el-table-column prop="student_info.student_email" label="Email" width="180"></el-table-column>
        <el-table-column prop="application_team_role" label="Team Role">
          <template slot-scope="scope">
            {{ scope.row.application_team_role == '领队' ? 'Leader' : 'Member' }}
          </template>
        </el-table-column>
      </el-table>

      <el-label v-if="teamChange.teamSearchText != '' && teamChange.team_apps.length > 0">Please confirm if this is the
        team
        you want to join. If so, click "Join" to join the team.</el-label>
      <el-label v-if="teamChange.teamSearchText != '' && teamChange.team_apps.length == 0">No registration found for
        this
        email. Please check the email for any errors.</el-label>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeTeamChange">Cancel</el-button>
        <el-button  element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.2)" type="primary" @click="submitTeamChange()">
          Confirm to Join</el-button>
      </div>
    </el-dialog>
  </article>
</template>
<script>
import studentTheme from "../common/studentTheme"
import {
  submitProject,
  updateNimApplicationTeamCode,
  getStudentNIMApplication,
  removeNimApplication,
  createNewTeamCode,
  searchTeamByLeaderEmail,
  getStudentInfo

} from "../service.js";

import Cookie from "js-cookie";

import Clipboard from "clipboard";
import { shouldShowResultViewEarly } from '../common/devFlags'
import { isResultsPublished } from '../common/applicationCycle'

export default {
  mixins: [studentTheme],
  data() {
    return {
      loginType: Cookie.get("loginType"),
      loginId: Cookie.get("loginId"),
      loginEmail: Cookie.get("loginEmail") || '',
      // project_code: Cookie.get("loginProject"),
      activeName: 'first',
      defevent: 0,

      projectLists: [],
      pendingList: [],
      historyList: [],
      showOngoing: false,
      teamChange: {
        show: false,
        title: 'Join A Team',
        app: {},
        teamSearchText: '',
        team_apps: []
      },

    };
  },
  created() {


  },
  mounted() {
    this.ensureLoginEmail().then(() => {
      this.getAppByEvent()
    })
  },
  methods: {
    ensureLoginEmail() {
      if (this.loginEmail || this.loginType !== '学生' || !this.loginId) {
        return Promise.resolve()
      }
      return getStudentInfo({ student_id: this.loginId }).then((res) => {
        if (res && res.code === 0 && res.data && res.data.student_info) {
          this.loginEmail = res.data.student_info.student_email || ''
          if (this.loginEmail) {
            Cookie.set('loginEmail', this.loginEmail)
          }
        }
      }).catch(() => { })
    },

    // Project status 已完成 (inactive) in the admin: no more editing, only the public read-only page.
    isProjectCompleted(application) {
      return application && application.project_status === 'inactive'
    },

    viewPublicProject(application) {
      window.open('https://www.nextideamatters.com/#/project?id=' + encodeURIComponent(application._id.$id), '_blank', 'noopener,noreferrer')
    },

    gotoAwardView(application) {
      this.$router.push({
        path: '/cert',
        query: {
          id: application._id.$id,
          tab: 'certificate'
        }
      })
    },

    checkShowCertView(application) {
      if (!application.submission_date) {
        return false
      }
      if (shouldShowResultViewEarly(this.loginEmail)) {
        return true
      }
      const entry_date = (application.projectManage && application.projectManage.entry_date) || []
      return isResultsPublished(entry_date, application.submission_date)
    },

    formatPublishDate(application) {
      let submission_date = application.submission_date * 1000
      let entry_date = (application.projectManage && application.projectManage.entry_date) || []
      let publish_date = 0
      let one_day = 24 * 60 * 60 * 1000 - 1
      for (let i = 0; i < entry_date.length; i++) {
        let item = entry_date[i]
        let start_date = item.start_date
        let ddl_date = item.ddl_date + one_day
        if (submission_date >= start_date && submission_date <= ddl_date) {
          publish_date = item.announce_date
        }
      }
      return this.convertTimeToEng(publish_date)
    },

    checkSubmitBtnStatus(application) {

      let entry_date = (application.projectManage && application.projectManage.entry_date) || []
      let one_day = 24 * 60 * 60 * 1000 - 1
      let current_time = new Date().getTime()


      if (application.submission_date && application.submission_date != '') {//已经提交过了
        //查看是否是到了证书发布的时间
        let publish_date = 0
        let submission_date = application.submission_date * 1000
        for (let i = 0; i < entry_date.length; i++) {
          let item = entry_date[i]
          let start_date = item.start_date
          let ddl_date = item.ddl_date + one_day
          if (submission_date >= start_date && submission_date <= ddl_date) {
            publish_date = item.announce_date
          }
        }
        if (current_time >= publish_date) {
          return 'cert'
        }
        return 'disabled'
      }
      //没有提交，check时间
      for (let i = 0; i < entry_date.length; i++) {
        let item = entry_date[i]
        let start_date = item.start_date
        let ddl_date = item.ddl_date + one_day
        if (current_time >= start_date && current_time <= ddl_date) {
          return 'show'
        }
      }
      return 'no-show'
    },

    doSubmitProject(item) {
      this.$confirm("Are you sure you want to submit your team's project? Once submitted, no further edits or changes can be made. The content you've entered and the project video you've uploaded currently will be used for evaluation. If you're ready to submit, please click \"Confirm.\"", 'Submission Confirmation', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showCancelButton: true,
        callback: action => {
          if (action == 'confirm') {
            submitProject(item._id.$id).then((res) => {
              if (res.data && res.data.code === 0) {
                this.$message.success('Submission Successful')
                this.getAppByEvent()
              } else {
                this.$message.error((res.data && res.data.msg) || 'Submission failed')
              }
            })
          }
        }
      })
    },

    isTeamReady(item) {
      return item.application_team_code !== '' && item.application_team_code !== '-' && item.team_size_valid !== false
    },

    teamStatusText(item) {
      if (!item.application_team_code || item.application_team_code === '-') {
        return 'Awaiting Team Confirmation'
      }
      if (item.team_size_valid === false) {
        const count = Number(item.team_member_count || 0)
        const min = Number(item.team_size_min || 0)
        const max = Number(item.team_size_max || 0)
        if (max > 0 && count > max) {
          return `Team Invalid (${count}/${max} max)`
        }
        return `Team Pending (${count}/${min || '-'} min)`
      }
      return `#${item.application_team_code}`
    },

    teamPendingHint(item) {
      if (item.application_team_code && item.application_team_code !== '-' && item.team_size_valid === false) {
        const count = Number(item.team_member_count || 0)
        const min = Number(item.team_size_min || 0)
        const max = Number(item.team_size_max || 0)
        if (max > 0 && count > max) {
          return `Your team currently has ${count} eligible members; the maximum is ${max}. Please contact your advisor.`
        }
        return `Your team currently has ${count} eligible members; the minimum is ${min}.`
      }
      return 'Please remind your advisor to assign you to a team.'
    },

    toPlainText(value) {
      if (value == null) return ''
      const element = document.createElement('div')
      element.innerHTML = String(value).replace(/<(?:br\b[^>]*|\/p\s*|\/div\s*|\/li\s*)>/gi, ' ')
      return (element.textContent || element.innerText || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim()
    },


    createNimImgResource(project_code) {
      if (project_code == '2025NSI') {
        return require('../assets/nsi_logo.png')
      }
      if (project_code == '2025NRI') {
        return require('../assets/nri_logo.png')
      }
      if (project_code == '2025NIR') {
        return require('../assets/nir_logo.png')
      }
      if (project_code == '2025NIP') {
        return require('../assets/nip_logo.png')
      }
      if (project_code == '2025NIA') {
        return require('../assets/nia_logo.png')
      }
      if (project_code == '2025NIE') {
        return require('../assets/nie_logo.png')
      }
      if (project_code == '2025NII') {
        return require('../assets/nii_logo.png')
      }
      if (project_code == '2025NIV') {
        return require('../assets/niv_logo.png')
      }
      return ''
    },

    getAppByEvent() {

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });


      getStudentNIMApplication(this.loginId, '', 'NIM').then((res) => {

        loading.close()

        if (res.data.code == 0) {

          this.pendingList = []
          this.projectLists = []
          this.historyList = []

          var allData = res.data.data

          for (let i = 0; i < allData.length; i++) {
            var app = allData[i]

            if (app.show_type == 'pending') {
              this.pendingList.push(app)
            }

            if (app.show_type == 'Ongoing') {
              console.log('111')
              if (app.application_team_code != '') {
                let submit_status = this.checkSubmitBtnStatus(app)
                app.submit_status = submit_status
              }
              this.projectLists.push(app)
            }

            if (app.show_type == 'History') {
              this.historyList.push(app)
            }


          }

          if (this.pendingList.length <= 0) {
            this.showOngoing = false
            this.activeName = 'second'

          } else {
            this.showOngoing = true
            this.activeName = 'first'
          }



        } else {
          this.$message.error(res.msg);
        }

      });






    },




    RemoveItem(item) {



      var projectName = item.project_name || item.event || item.application_project || 'this project'
      var info = 'Are you sure you want to withdraw your registration for ' + projectName + '?'

      this.$confirm(info, 'Cancel Registration', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Close',
        type: 'warning'
      }).then(() => {

        removeNimApplication(item._id.$id).then(res => {


          if (res.data.code === 0) {
            this.$message({
              message: 'Registration Cancelled Successfully.',
              type: 'success'
            })
            this.getAppByEvent()

          }
        })
      })

    },


    gotoEAE(item) {
      const params = new URLSearchParams({
        student_id: this.loginId,
        login_type: this.loginType,
        application_id: item._id.$id,
        redirect_path: '/pay'
      })
      window.open('https://my.eae.international#/login?' + params.toString(), '_blank')
    },

    gotoPay(item) {
      this.$router.push({
        path: '/pay',
        query: {
          id: item._id.$id
        }
      })
    },



    manageProject(item) {

      if (item.application_status !== '已缴费' && item.application_status !== '无需缴费') {
        this.$message.error("You haven't paid yet")
        return
      }


      Cookie.set("projectTeamRole", item.application_team_role);

      if (item.application_events && item.application_events.length > 0) {
        Cookie.set("projectTeamEvent", item.application_events[0]);
      } else {
        Cookie.set("projectTeamEvent", item.application_project);
      }


      // mr 模版id  631169b9a4640b60318b4602
      // poe 模版id  63116846a4640b19318b4567
      // pie 模版id  63116951a4640b60318b4567

      // let pathTemplate_id = '631169b9a4640b60318b4602'

      // if (this.application.program==='PIE'){
      //   pathTemplate_id = '63116846a4640b19318b4567'

      // }else if (this.application.program==='POE'){
      //   pathTemplate_id = '63116951a4640b60318b4567'

      // }

      // if (this.from == 'student') {
      if (item.coordinator_id && item.coordinator_id != '') {
        const routeData = this.$router.resolve({
          path: 'pghome',
          query: {
            application_id: item._id.$id,
            application_team_role: item.application_team_role,
            template_id: item.template_id,
            project_id: item.project_id,
            application_team_code: item.application_team_code,
            accountid: item.coordinator_id
          }
        })
        window.open(routeData.href, '_blank')
      } else {
        const routeData = this.$router.resolve({
          path: 'pghome',
          query: {
            application_id: item._id.$id,
            application_team_role: item.application_team_role,
            template_id: item.template_id,
            project_id: item.project_id,
            application_team_code: item.application_team_code,
            accountid: item.account_id
          }
        })
        window.open(routeData.href, '_blank')

      }

    },

    getPdf(item) {

      this.$router.push({
        path: 'toPrint',
        query: {
          project_id: item.project_id,
          account_id: item.account_id,
          team_code: item.application_team_code,
          project_product: 'NIM',
          block_id: '',
          template_id: item.template_id
        }
      })
    },
    changeTeam(row, title) {
      this.teamChange.title = title;
      this.teamChange.app = row;
      this.teamChange.show = true;
      this.teamSearchText = '';
      this.team_apps = [];

    },
    closeTeamChange() {
      this.teamChange.show = false;
    },
    createTeam(row) {

      createNewTeamCode(row._id.$id).then((res) => {

        if (res.data.code == 0) {

          this.getAppByEvent();

        } else {
          this.$message.error(res.msg);
        }

      });

    },

    handleTeamSearch() {
      searchTeamByLeaderEmail(this.teamChange.teamSearchText, this.teamChange.app.application_project).then((res) => {

        if (res.data.code == 0) {

          this.teamChange.team_apps = res.data.data;

        } else {
          this.$message.error(res.msg);
        }

      });
    },
    submitTeamChange() {
      if (!this.teamChange.team_apps.length) {
        this.$message.error('Please search for and select a valid team first.')
        return
      }

      const app = this.teamChange.app
      const targetTeamCode = String(this.teamChange.team_apps[0].application_team_code || '')
      const currentTeamCode = String(app.application_team_code || '')
      const min = Number(app.team_size_min || 0)
      const max = Number(app.team_size_max || 0)
      const targetMemberIds = new Set(this.teamChange.team_apps.map(item => item._id && item._id.$id).filter(Boolean))
      const targetCount = targetMemberIds.size + (currentTeamCode === targetTeamCode ? 0 : 1)
      if (max > 0 && targetCount > max) {
        this.$message.error(`This team would have ${targetCount} eligible members; the maximum is ${max}.`)
        return
      }
      const currentCount = Number(app.team_member_count || 0)
      const remainingCount = currentCount - 1
      if (currentTeamCode && currentTeamCode !== '-' && currentTeamCode !== targetTeamCode
        && min > 0 && currentCount >= min && remainingCount > 0 && remainingCount < min) {
        this.$message.error(`Leaving your current team would leave ${remainingCount} eligible members; the minimum is ${min}.`)
        return
      }

      updateNimApplicationTeamCode(app._id.$id, targetTeamCode).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: res.data.team_size_valid
              ? 'Team confirmed.'
              : `Team assignment saved. ${res.data.have_count || 0}/${res.data.team_size_min || 0} eligible members have joined.`,
            type: res.data.team_size_valid ? 'success' : 'warning'
          })
          this.closeTeamChange();
          this.getAppByEvent();
        } else {
          this.$message.error(res.data.msg || 'Unable to update the team.')
        }
      }).catch(() => {
        this.$message.error('Unable to update the team.')
      })
    },


    convertTimeToEng(time) {
      var date = new Date(time);
      let year = date.getFullYear();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      return this.formatMonthToEng(month) + " " + day + ", " + year;
    },

    formatMonthToEng(month) {
      switch (month) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },

    closeDialog(){

    },
    openDialog(){

    }
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.newItem {
  margin-top: 15px;
  display: flex;
  align-items: center;
  padding: 5px 15px;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  min-height: 160px;
  background-color: white;
  border: 1px solid #204386;
  border-radius: 5px;

  .manageStyle1 {
    text-align: center;
    background-color: #ffb414;
    border: none;
    color: #333;
  }

  .advisorHintStyle {
    max-width: 260px;
    text-align: right;
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .leaderStyle {
    color: #333;
    font-size: 18px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .memberStyle {
    margin-top: 5px;
    color: #333;
    font-size: 18px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .projectTitleStyle {
    flex: 1;
    padding-top: 5px;
    box-sizing: border-box;
    color: #333;
    font-size: 25px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .infoStyle {
    font-size: 15px;
  }

  .teamCodeStyle {
    color: #333;
    font-size: 15px;
  }

  .teamCodeStyle1 {
    background-color: #204386;
    width: 185px;
    color: white;
    font-size: 15px;
  }
}

.newItem1 {
  background-color: white;
  border: 1px solid #ffb414;
}

article {

  background-color: rebeccapurple;
  // margin-left: 100px;
  // margin-top: 50px;
  background: #fff;
  // padding: 0 10px;

  .el-tabs_item.is-active {
    font-size: 14px;
    font-weight: 500;
    color: #204386;
  }

  .el-tabs_active-bar {
    background-color: #ffb414;
  }

  .el-tabs_item {
    font-size: 20px;
    font-weight: 500;
    color: aquamarine;
  }


  .homeContainer {
    height: calc(100vh - 58px);
    width: 100%;
    display: flex;
    overflow: hidden;
    background: #fff;
    font-family: "GravityBookItalic-zpra";

    .mainView {
      margin-left: 10%;
      margin-right: 10%;
      flex: 1;
      // width: 60%;
      height: 100%;
      background: white;
      overflow: hidden;
      position: relative;
    }

    .projectList {
      margin-top: 20px;
      // background-color: red;
      height: 70vh;
      width: 100%;
      overflow-y: auto;
      position: relative;

    }

    .itemStyle {
      // margin-left: 20px;
      // margin-right: 20px;
      margin-top: 15px;
      width: 100%;
      position: relative;
      min-height: 150px;
      padding-bottom: 60px;
      background-color: oldlace;
      border-radius: 5px;
    }

    .itemStyle2 {
      // margin-left: 20px;
      // margin-right: 20px;
      margin-top: 15px;
      width: 100%;
      position: relative;
      min-height: 150px;
      padding-bottom: 60px;
      background-color: #c3cce9;
      border-radius: 5px;
    }

    .historyContent {
      padding: 10px;
      padding-bottom: 0;
    }

    .historyButtons {
      position: absolute;
      bottom: 15px;
      right: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
    }

  }



  .teamCodeStyle {
    padding: 5px 10px;
    display: inline-block;
    color: #333;
    font-size: 15px;
  }

  .teamCodeStyle1 {
    background-color: #204386;
    display: inline-block;
    padding: 5px 10px;
    margin-bottom: 5px;
    color: white;
    font-size: 15px;
  }


  .projectTitleStyle {
    margin-left: 10px;
    margin-top: 5px;
    color: #333;
    font-size: 25px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .projectTitleStylePending {
    margin-left: 10px;
    margin-top: 38px;
    color: #333;
    font-size: 25px;
  }

  .leaderStyle {
    margin-left: 10px;
    margin-top: 25px;
    color: #333;
    font-size: 18px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .memberStyle {
    margin-left: 10px;
    margin-top: 5px;
    color: #333;
    font-size: 18px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .infoStyle {
    position: absolute;
    right: 10px;
    top: 15px;
    width: 80%;
    text-align: right;
    font-size: 15px;
  }

  .manageStyle2 {
    // width: 80px;
    text-align: center;
    background-color: #ffb414;
    border: none;
    color: #333;
  }

  .manageStyle3 {
    text-align: center;
    background-color: #F2F2F2;
    border: none;
    color: #666;
  }

  .manageStyle {
    // width: 80px;
    text-align: center;
    background-color: #ffb414;
    border: none;
    color: #333;
  }

  .manageStylePending {
    position: absolute;
    bottom: 15px;
    right: 10px;
    width: 80px;
    text-align: center;
    background-color: #204386;
    border: none;
    color: white;
  }

  .removeStyle {
    position: absolute;
    bottom: 15px;
    right: 100px;
    width: 80px;
    text-align: center;
    background-color: #ffb414;
    border: none;
    color: #333;
  }

  .removeStylePending {
    position: absolute;
    bottom: 15px;
    right: 100px;
    width: 80px;
    text-align: center;
    background-color: #204386;
    border: none;
    color: white;
  }

  .pendingButtons {
    position: absolute;
    bottom: 15px;
    right: 100px;
    display: flex;
    gap: 15px;
  }

  .pendingBtn {
    text-align: center;
    background-color: #204386;
    border: none;
    color: white;
  }

  .eventLinkStyle {
    margin-left: 10px;
    margin-right: 10px;
    height: 40px;
    margin-top: 10px;
    width: calc(100% - 20px);
  }

  .eventName {
    color: #333;
    padding-right: 10px;
    // width: 230px;
    height: 30px;
    text-align: right;
    line-height: 30px;
    // font-size: 18px;
    background-color: oldlace;
    // float: left;

  }

  .linkStyle {
    height: 30px;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 30px;
    background-color: #f5f5f5;

    overflow: hidden;
    /* 隐藏超出内容的区域 */
    white-space: nowrap;
    /* 不允许文本折行 */
    text-overflow: ellipsis;
    /* 显示省略号代替超出部分的文本 */
  }

  .shareBtn {
    line-height: 30px;
    width: 80px;
    height: 30px;
    text-align: center;
    background-color: #ffb414;

  }

}
</style>
